<template>
    <div id="prenavbar">
        <div class="container text-center">
            <h4 class="regular">TRABAJA CON NOSOTROS. REVISA NUESTRAS OFERTAS LABORALES <a href="https://www.facebook.com/profile.php?id=100075919491900" target="_blank">AQUÍ</a></h4>
        </div>
    </div>
</template>